module.exports = __webpack_public_path__ + "static/media/bootstrap4.ffded238.svg";